import snakecaseKeys from 'snakecase-keys';

type snakeCaseInput = { [key: string]: unknown; } | Array< { [key: string]: unknown; } >;

/**
 * Takes an object or array of objects and transforms keys to be snake-case.
 * @example <caption>simple objects</caption>
 * interface SimpleRailsPayload { some_prop: string, nested_prop: {nested_simple_prop: number} };
 *
 * snakeCaseTransformer<SimpleRailsPayload>({someProp: 'a', nestedProp: {nestedSimpleProp: 5}});
 * // returns [{some_prop: 'a', nested_prop: {nested_simple_prop: 5}}];
 *
 * @example <caption>simple array</caption>
 * snakeCaseTransformer<SimpleRailsPayload[]>([{someProp: 'a', nestedProp: {nestedSimpleProp: 5}}]);
 * // returns [{some_prop: 'a', nested_prop: {nested_simple_prop: 5}}];
 *
 * */
export function snakeCaseTransformer<T>(input: unknown): T {
  return snakecaseKeys(input as snakeCaseInput, { deep: true }) ;
}
